/**
 * Texts for FAQs page
 */
export const faqPageText = {
    title: 'Perguntas frequentes - CamAPS FX',
    titleMeta: 'Tem alguma questão sobre o CamAPS FX?',
    descriptionMeta: 'Aqui encontra respostas a algumas das perguntas mais frequentes sobre dispositivos compatíveis, ' +
        'aprovação regulamentar, disponibilidade e investigação clínica',
    keywords:
        'perguntas frequentes camaps, perguntas frequentes camaps fx, ',
    localeMeta: 'pt_PT',

    haveQuestion: 'Tem alguma questão sobre o CamAPS FX?',
    hereAnswers: 'Aqui encontra respostas a algumas das perguntas mais frequentes.',
    whatIsCamAPS: 'O que é o CamAPS FX?',
    whatIsCamAPSAnswer: 'O CamAPS FX é uma aplicação móvel sofisticada e fácil de utilizar para gerir os níveis de glicose em pessoas ' +
        'com diabetes tipo 1, a partir de um ano de idade, através de uma abordagem avançada e adaptativa de circuito fechado híbrido.',
    isApproved: 'O CamAPS FX está aprovado para utilização?',
    isApprovedAnswer: 'A aplicação foi amplamente testada em ensaios clínicos e aprovada para ' +
        'utilização, incluindo no Reino Unido, na UE, nos EUA, no Canadá, na Austrália e na Nova Zelândia.',
    isAvailable: 'O CamAPS FX está disponível na minha região?',
    isAvailableAnswer1: 'O CamAPS FX está disponível em algumas clínicas de diabetes. Consulte a sua clínica.',
    isAvailableAnswer2: '',
    isAvailableAnswer3: '',
    whatIsLiberty: 'O que é o CamAPS Liberty?',
    whatIsLibertyAnswer: 'O CamAPS Liberty é uma funcionalidade da aplicação CamAPS FX. Quando ativada, os utilizadores não precisam de contar hidratos de carbono nem de administrar um bólus para as refeições e lanches.',
    whatIsLibertyMoreInfo1: 'Para mais informações, visite a nossa ',
    whatIsLibertyPageLink: 'página do CamAPS Liberty',
    whatIsLibertyMoreInfo2: ' ou descarregue esta ',
    whatIsLibertyFactsheetLink: 'ficha informativa',
    whatIsLibertyMoreInfo3: '.',
    whatIsLibertyFactsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_en.pdf',
    cost: 'Quanto custa o CamAPS FX?',
    costAnswer1: 'Para informações sobre preços, consulte a',
    costAnswer2: 'secção do website.',
    compatibleCgm: 'Que sistemas de monitorização contínua da glicose (CGM) são compatíveis com o CamAPS FX?',
    compatibleCgmBody: 'O CamAPS FX é compatível com o Dexcom G6, o Dexcom G7, o FreeStyle Libre 3 e o FreeStyle Libre 3 Plus. Clique nas ligações para consultar os smartphones e sistemas operativos compatíveis.',
    whatPumps: 'Que bombas de insulina são compatíveis com o CamAPS FX?',
    whatPumpsAnswer1: 'No Google Play, o CamAPS FX é compatível com as bombas de insulina YpsoPump, DANA Diabecare RS e DANA-i. Na Apple App Store, é atualmente compatível apenas com a YpsoPump.',
    whatPumpsAnswer2: '',
    whatPumpsAnswer3: '',
    whatPumpsAnswerHtml: 'https://advancedtherapeutics.org.uk/shop/dana-diabecare-insulin-pump/dana-i-insulin-pump',
    whatPhone: 'Que smartphones são compatíveis com o CamAPS FX?',
    whatPhoneAnswer: 'O seu smartphone tem de ser compatível com o CGM que utiliza.',
    cgmManufacturerListText: 'Consulte a lista de compatibilidade do fabricante do CGM para o Dexcom G6, o Dexcom G7, o FreeStyle Libre 3 ou o FreeStyle Libre 3 Plus.',
    whatOperating: 'Que sistemas operativos são compatíveis com o CamAPS FX?',
    whatOperatingAnswer: 'O CamAPS FX é compatível com o Android 13 a 16 e o iOS 18 a 27, incluindo atualizações secundárias posteriores. O seu sistema operativo também tem de ser compatível com o CGM que utiliza.',
    whatOperatingManufacturerText: 'Consulte a lista de compatibilidade do fabricante do CGM para o Dexcom G6, o Dexcom G7, o FreeStyle Libre 3 ou o FreeStyle Libre 3 Plus.',
    whatPhoneAnswerDexcomHtml:'https://www.dexcom.com/en-GB/compatibility/g6',
    whatPhoneAnswerDexcomG7Html:'https://www.dexcom.com/en-GB/compatibility/g7',
    whatPhoneAnswerLibreHtml:'https://freestyleserver.com/Payloads/IFU/2026/q2/ART43193-006_rev-AP-pub.pdf',

    whereUpload: 'Para onde posso carregar os meus dados a partir do CamAPS FX?',
    whereUploadAnswer: 'Atualmente, os dados do CamAPS FX podem ser carregados para a mylife Cloud e o Glooko.',
    whatLanguage: 'Em que idiomas está disponível o CamAPS FX?',
    whatLanguageAnswer: 'O CamAPS FX está disponível em inglês, checo, dinamarquês, neerlandês, francês, finlandês, alemão, italiano, norueguês, polaco, português, espanhol e sueco.',
    whereResults: 'Onde posso consultar os resultados dos vossos ensaios clínicos?',
    whereResultsAnswer1: 'As publicações relacionadas com a utilização do algoritmo de controlo de Cambridge estão disponíveis para descarregar',
    whereResultsAnswer2: 'aqui.',
    whereResultsAnswer3: 'As principais publicações foram publicadas nas revistas',
    whereResultsAnswer4: 'e',

    wantMoreInfoIOS: 'Pretende saber mais sobre a aplicação CamAPS FX para iOS?',
    wantMoreInfoIOSanswer1: '',
    wantMoreInfoIOSanswer2: 'Clique aqui',
    wantMoreInfoIOSanswer3: 'para saber mais.',
    wantMoreInfoIOSanswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/iOS+FAQ_EN_005.pdf',

    wantMoreInfoCGManswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/Sensor_FAQs_EN.pdf',

    danaOnGooglePlayHeading: 'Como podem os utilizadores de bombas Dana descarregar o CamAPS FX a partir do Google Play?',
    danaOnGooglePlayAnswer1: 'Clique aqui',
    danaOnGooglePlayAnswer2: 'clique aqui',
    danaOnGooglePlayAnswer3: 'para saber mais.',
    danaOnGooglePlayAnswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/downloading_dana_camaps_fx.pdf',

};
